import React, { Fragment } from 'react'
import LayoutEN from '../layouts/en'
import LayoutPT from '../layouts/pt'
import { graphql } from 'gatsby'

import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

import * as S from './styles/BlogIndex.styled'
import ItemList from '../components/Blog/ItemList/ItemList'
import Pagination from '../components/Blog/Pagination/Pagination';
import HeaderPage from '../components/Blog/HeaderPage/HeaderPage'
import HeadIndexBlog from '../components/Blog/HeadIndexBlog'
import RDStation from '../components/RDStation'

const BlogIndex = ({ data, ...props }) => {
  const site = data.site.siteMetadata
  const posts = data.allMarkdownRemark.edges;
  const pageInfo = data.allMarkdownRemark.pageInfo;

  const Layout = ({ children }) => {
    switch (props.pageContext.langKey) {
      case 'pt-br':
        return (
          <LayoutPT location={props.location}>
            {children}
          </LayoutPT>
        )
      default:
        return (
          <LayoutEN location={props.location}>
            {children}
          </LayoutEN>
        )
    }
  }

  return (
    <Layout>
      <HeadIndexBlog page={pageInfo.currentPage} />
      <div>
        <Header />
        <div className="container">
          <HeaderPage page="homeBlog" pageInfo={pageInfo} />
          <S.ListPosts>
            {posts.map(post => <ItemList key={post.node.id} authors={site.authors} data={post.node} />)}
            <Pagination pageInfo={pageInfo} />
          </S.ListPosts>
        </div>
        <S.Newsletter>
          <div className="container">
            {props.pageContext.langKey === 'pt-br' && (
              <Fragment>
                <h3>Você gostou do nosso conteúdo?</h3>
                <h4>Assine nossa newsletter e fique ligado</h4>
                <RDStation
                  portalId="20305269"
                  formId="b37cc075-b68f-4ed1-a602-14d95d61cedb"
                  loading={<div>Loading...</div>}
                />
              </Fragment>
            )}
            {props.pageContext.langKey !== 'pt-br' && (
              <Fragment>
                <h3>Wanna stay tuned to our news?</h3>
                <h4>Sign up to our newsletter</h4>
                <RDStation
                  portalId="20305269"
                  formId="4ef3c15c-3912-4c3a-ac3e-7b5257d6d7b1"
                  loading={<div>Loading...</div>}
                />
              </Fragment>
            )}
          </div>
        </S.Newsletter>
        <Footer />
      </div>
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query($langKey: String!, $skip: Int!, $limit: Int!) {
    site {
      siteMetadata {
        title
        authors {
          wepayout {
            avatar
            linkedin
            name
          }
          zago {
            avatar
            linkedin
            name
          }
          nunes {
            avatar
            linkedin
            name
          }
          nery {
            avatar
            linkedin
            name
          }
        }
      }
    }
    allMarkdownRemark(
      filter: { fields: { langKey: { eq: $langKey } } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        perPage
        pageCount
        totalCount
      }
      edges {
        node {
          id
          fields {
            slug
            langKey
          }
          excerpt(truncate: true, format: PLAIN, pruneLength: 200)
          timeToRead
          frontmatter {
            date(formatString: "DD/MM/YYYY")
            title
            tags
            author
            coverImage
            shareImage
            slug
          }
        }
      }
    }
  }
`;